export enum InputSize {
  large,
  small,
}
